import React, { useState, useRef, useEffect } from 'react'
import styled from 'styled-components'
import ReactPlayer from 'react-player/lazy';
import axios from 'axios';


const midTileBg = "https://d3bb2njoyzhxtr.cloudfront.net/static/mid_tile_bg.svg";
const midTileArrow = "https://d3bb2njoyzhxtr.cloudfront.net/static/mid_tile_arrow.svg";
const midStatTileImg = "https://d3bb2njoyzhxtr.cloudfront.net/static/mid_stat_tile_img.svg";
const bgLandingMid = "https://d3bb2njoyzhxtr.cloudfront.net/static/bg_landing_mid.svg";
const whiteArrow = "https://d3bb2njoyzhxtr.cloudfront.net/static/read_story_arrow.svg";
const caseStudyVideo = "https://d3bb2njoyzhxtr.cloudfront.net/static/case_study_video.mp4";
const caseStudyVideoPoster = "https://d3bb2njoyzhxtr.cloudfront.net/static/case_study_thumb.webp";
const avatarCaseStudy = "https://d3bb2njoyzhxtr.cloudfront.net/static/tyrone_davis_avatar.webp"
const playIcon = "https://d3bb2njoyzhxtr.cloudfront.net/static/play_button_icon.svg";


const MidSection = styled.section`
  width: 100%;
  background: #fff;
  position: relative;
  padding: 80px 0 0 0;
  margin: 0;

  @media (max-width: 900px) {
    padding: 0 0 0 0;
  }
`;

const MidSectionBg = styled.img`
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  min-width: 1200px;
  pointer-events: none;
  z-index: 0;

  @media (max-width: 1200px) {
    left: 50%;
    transform: translateX(-50%);
  } 
`;

const MidSectionContent = styled.div`
  position: relative;
  z-index: 1;
  max-width: 1250px;
  margin: 0 auto;
  padding: 0 25px 120px 25px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media (max-width: 900px) {
    padding: 25px;
  }

`;

const MidSectionTitle = styled.h2`
  font-size: 2.3rem;
  font-weight: 600;
  color: #2D0F29;
  margin-bottom: 18px;
  margin-top: 0;
  line-height: 1.18;
  letter-spacing: -0.5px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;

  @media (max-width: 900px) {
    line-height: 1.2;
    font-size: 1.8rem;
    margin-bottom: 12px;
  }
`;

const MidSectionHighlight = styled.span`
  color: #DC4AE1;
  font-family: Poppins, sans-serif;
  font-weight: 600;
`;

const MidSectionText = styled.p`
  color: #757285;
  font-size: 1.08rem;
  font-weight: 400;
  margin: 0 0 0.5em 0;
  max-width: 600px;
`;

const MidSectionGrid = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 18px;
  margin-top: 10px;

  @media (max-width: 900px) {
    flex-direction: column;
    gap: 18px;
  }
`;

const MidTile = styled.div`
  background: #F5F5F6;
  border-radius: 18px;
  padding: 24px 24px 24px 28px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  position: relative;
  min-height: 100px;
  overflow: hidden;

  @media (max-width: 900px) {
    min-height: 200px;
  }
`;

const MidTileFlex = styled(MidTile)`
  flex: 1 1 0;
  min-width: 0;
  max-width: 100%;
  

  @media (max-width: 900px) {
    flex: 1 1 100%;
    min-width: 0;
    max-width: 100%;
    width: 100%;
  }
`;


const UpperRightTile = styled(MidTileFlex)`
  height: 325px;
  
  &:hover {
    box-shadow: 0 4px 24px 0 rgba(60,60,90,0.20);
  }

  @media (max-width: 900px) {
    height: auto;
  }
`;


const MidSectionGridRow = styled.div`
  display: flex;
  gap: 15px;
  width: 100%;

  @media (max-width: 900px) {
    flex-direction: column;
    gap: 18px;
  }
`;


const MidTileText = styled.div`
  color: #2D0F29;
  font-size: 1.6rem;
  font-weight: 600;
  margin-bottom: 20px;
  max-width: 100%;

   @media (max-width: 1200px) {
    font-size: 1.45rem;
    margin-bottom: 15px;
  }

    @media (max-width: 1200px) {
    font-size: 1.3rem;
    margin-bottom: 15px;
  }

  @media (max-width: 1050px) {
    font-size: 1.2rem;
    margin-bottom: 15px;
  }

  @media (max-width: 950px) {
    font-size: 1.05rem;
    margin-bottom: 12px;
  }

  @media (max-width: 900px) {
    font-size: 1.3rem;
  }
`;

const MidTileBottomLeftText = styled(MidTileText)`
  font-size: 1.3rem;

  @media (max-width: 1250px) {
    font-size: 1.2rem;
  }

    @media (max-width: 1200px) {
    font-size: 1.15rem;
  }

  @media (max-width: 1050px) {
    font-size: 1.1rem;
  }

  @media (max-width: 1000px) {
    font-size: 1.05rem;
  }

  @media (max-width: 900px) {
    font-size: 1.3rem;
  }
`;

const MidTileAuthor = styled.div`
  display: flex;
  align-items: flex-end;
  left: 28px;
  margin-top: 35px;
  gap: 12px;
  bottom: 24px;
  height: 100%;


  @media (max-width: 900px) {
    margin-top: 20px;
    gap: 8px;
  }
`;

const MidTileAuthorImg = styled.img`
  width: 44px;
  height: 44px;
  border-radius: 6px;
  object-fit: cover;
`;

const MidTileAuthorInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;

`;

const MidTileAuthorName = styled.div`
  color: #21283E;
  font-size: 0.9rem;
  font-weight: 700;
`;

const MidTileAuthorDesc = styled.div`
  color: #21283E;
  opacity: 0.6;
  font-size: 0.88rem;
  font-weight: 500;

  @media (max-width: 900px) {
    font-size: 0.7rem;
  }
`;

const MidTileStats = styled.div`
  display: flex;
  gap: 32px;

  margin-bottom: 20px;
`;

const MidTileStat = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const MidTileStatValue = styled.div`
  color: #2D0F29;
  font-size: 1.5rem;
  font-weight: 800;
  font-family: Poppins, sans-serif;
  font-weight: 600;
`;

const MidTileStatDesc = styled.div`
  color: #21283E;
  opacity: 0.6;
  font-size: 0.98rem;
  font-weight: 500;
`;

const MidTileCtaRight = styled.a`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  background: #2D0F29;
  color: #fff;
  font-size: 0.9rem;
  font-weight: 600;
  border: none;
  border-radius: 8px;
  padding: 10px 20px;
  cursor: pointer;
  margin-top: 0px;
  margin-bottom: 0;
  transition: background 0.15s;
  text-decoration: none;

  width: 140px;

  &:hover {
    background: #DC4AE1;
  }
  left: unset;
`;

const MidTileAuthorRight = styled.div`
  display: flex;
  align-items: center;
  left: 28px;
  gap: 12px;
  bottom: 24px;
`;

const RightTileBottom = styled.div`
  display:flex;
  align-items: flex-end;
  justify-content: space-between;
  bottom: 24px;
  width: 100%;
  height: 100%;
`;


const DisclaimerText = styled.div`
  color: #8c8f93;
  font-size: 12px;
  text-align: left;
  margin-top: 10px;
  max-width: 210px;
  
  a {
    color: #DC4AE1;
    text-decoration: underline;
  }
`;

const CtaWrapper = styled.div`
  display:flex;
  flex-direction:column;
  align-items: flex-end;
  justify-content: flex-end;
`;

function getClipPath({
  carveTopY = 95,
  carveHorzY = 87,
  carveRightX = 180,
  maskWidth = 437,
  maskHeight = 344,
} = {}) {
  return `path(
    "M0 335.5V${carveTopY}C0 ${carveTopY - 4.4183} 3.58172 ${carveHorzY} 8 ${carveHorzY}H${carveRightX}C${carveRightX + 4.418} ${carveHorzY} ${carveRightX + 8} ${carveHorzY - 3.5817} ${carveRightX + 8} ${carveHorzY - 8}V8C${carveRightX + 8} 3.58172 ${carveRightX + 11.582} 0 ${carveRightX + 16} 0H428.5C432.918 0 436.5 3.58173 436.5 8.00001V335.5C436.5 339.918 432.918 343.5 428.5 343.5H8C3.58172 343.5 0 339.918 0 335.5Z"
  )`;
}

const MidTileBottomLeft = styled(MidTileFlex)`


  cursor: pointer;

  &:hover {
    box-shadow: 0 4px 24px 0 rgba(60,60,90,0.20);
  }

  @media (max-width: 900px) {
    justify-content: space-around;
  }
`;

const MidTileCenter = styled(MidTileFlex)`
  background: url(${midTileBg}) center bottom/cover no-repeat;
  color: #fff;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  height: 325px;
  margin-top: -90px;
  z-index: 2;
  overflow: hidden;
  border-radius: 16px;

  clip-path: ${({ $carveTopY, $carveHorzY, $carveRightX }) =>
    getClipPath({
      carveTopY: $carveTopY,
      carveHorzY: $carveHorzY,
      carveRightX: $carveRightX,
    })};

    @media (max-width: 900px) {
      clip-path: none;
      margin-top: 0;
      min-height: 230px;
      height: auto;
      justify-content: center;
    }

  > * {
    position: relative;
    z-index: 20;
  }
`;

const MidTileCenterText = styled.div`
  color: #fff;
  font-size: 1.6rem;
  font-weight: 600;
  margin-bottom: 20px;
  max-width: 100%;
  line-height: 1.25;


    @media (max-width: 935px) {
      font-size: 1.5rem;
    }
`;

const MidTileCenterCTA = styled.a`
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-decoration: none;
  background: #fff;
  color: #21283E;
  font-size: 0.9rem;
  font-weight: 700;
  border: none;
  border-radius: 8px;
  padding: 8px 20px;
  width: 100%;
  max-width: 320px;
  cursor: pointer;
  box-shadow: 0 4px 24px 0 rgba(60,60,90,0.10);
  transition: background 0.15s, color 0.15s;

  &:hover {
    background: #f3f5f8;
    box-shadow: 0 6px 32px 0 rgba(60,60,90,0.13);
    // color: #DC4AE1;
  }

  img {
    margin-left: 18px;
    width: 22px;
    height: 22px;
    display: block;
  }
`;


const LowerRightTile = styled(MidTileFlex)`
  background: linear-gradient(120deg, #fbe7fb 35%, #fff 80%, #fff 100%);
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  min-height: 325px;
  margin-top: -90px;
  overflow: hidden;

  &::after {
    content: "";
    position: absolute;
    right: 0;
    bottom: 0;
    width: 350px;
    height: 350px;
    background: url(${midStatTileImg}) no-repeat right bottom;
    background-size: contain;
    pointer-events: none;
    z-index: 1;
  }
    &:hover {
    box-shadow: 0 4px 24px 0 rgba(60,60,90,0.20);
  }

  @media (max-width: 900px) {
  display: none;
}
    
`;

const MidStatValue = styled.div`
  color: #2D0F29;
  font-size: 3rem;
  line-height: 1.2;
  letter-spacing: -0.03em;
  font-weight: 600;
  font-family: Poppins, sans-serif;

  margin-bottom: 6px;
  position: relative;
  z-index: 2;
  @media (max-width: 1100px) {
    font-size: 2.5rem;
  }
`;

const MidStatSubtext = styled.div`
  color: #2D0F29;
  font-size: 1.01rem;
  font-weight: 500;
  opacity: 0.7;
  position: relative;
  z-index: 2;
`;

const VideoPlayer = styled.div`
  z-index: 5;
  position: relative;
  transform: scale(1);
  border-radius: 8px;
  width: 100%;
  overflow: hidden;
  transition: transform 500ms;
  margin-bottom: 5px;
  &:hover {
    transform: scale(1.03);
  }

  video {
    border-radius: 8px;
    position: absolute;
    top: 0;
    left: 0;
  }

  > div {
    padding-top: 56.25%;
    position: relative;
    border-radius: 8px;
  }
  .react-player__preview {
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 10px;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .react-player__shadow {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .play {
    transform: translate(-50%, -50%);
    left: 50%;
    top: 50%;
    cursor: pointer;
    background-color: rgba(255, 255, 255, 0.1);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    width: 80px;
    height: 80px;

    > img {
      width: 50%;
      height: 50%;
      margin-left: 7px;
    }
  }
`;

const PlayButton = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 4px;
  
  &:hover {
    background: rgba(255, 255, 255, 0.95);
  }
`;

const StatsRow = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 10px;

  @media (max-width: 900px) {
    flex-wrap: wrap;

    gap: 2px;
  }
`;

const StatColumn = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  @media (max-width: 900px) {
    flex: 0 0 48%;
    box-sizing: border-box;
    margin-bottom: 5px;
    &:nth-child(1) { order: 1; }
    &:nth-child(2) { order: 2; padding-left: 10px; }
    &:nth-child(4) { order: 3; }
    &:nth-child(3) { order: 4; padding-left: 10px;}
  }
`;

const StatValue = styled.div`
  color: #2D0F29;
  font-size: 1.5rem;
  font-family: Poppins, sans-serif;
  font-weight: 600;
  line-height: 1.2;
  margin-bottom: 5px;

  @media (max-width: 900px) {
    font-size: 1.3rem;
    margin-bottom: 2px;
  }
    
`;

const StatDescription = styled.div`
  color: rgba(33, 40, 62, 0.6);
  font-size: 0.72rem;
  font-weight: 500;
  line-height: 1.3;
  max-width: 100%;

  @media (max-width: 900px) {
    font-size: 0.6rem;
  }
    
`;


const VideoTile = styled(MidTileFlex)`
  z-index: 20;
  background: #F5F5F6;
  border-radius: 10px;
  height: 420px;
  padding: 18px 18px 10px 18px;

    &:hover {
    box-shadow: 0 4px 24px 0 rgba(60,60,90,0.20);
  }
`;


const LowerRow = styled(MidSectionGridRow)`
  gap: 15px;

  @media (max-width: 900px) {
    flex-direction: column;
    gap: 18px;
  }
`;

const MidSectionTextWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 25px;
  
  @media (max-width: 900px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
  }
`;

const MidSectionCTA = styled.button`
  background-color: #DC4AE1;
  color: white;
  font-size: 0.95rem;
  font-weight: 600;
  border: none;
  border-radius: 8px;
  padding: 12px 20px;
  cursor: pointer;
  white-space: nowrap;
  transition: background-color 0.2s;
  font-family: 'Inter', sans-serif;
  display:flex;
  align-items:center;
  justify-content:center;

  img {
    margin-left: 10px;
  }
  
  &:hover {
    background-color: #9a41a7;
  }
  
  @media (max-width: 900px) {
    align-self: flex-start;
  }
`;

const VideoModalOverlay = styled.div`
  position: fixed;
  z-index: 9999;
  inset: 0;
  background: rgba(0,0,0,0.92);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const VideoModalContent = styled.div`
  position: relative;
  width: 90vw;
  max-width: 1200px;
  background: transparent;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const VideoContainer = styled.div`
  position: relative;
  width: 100%;
  padding-top: 56.25%; /* 16:9 aspect ratio */
  
  @media (max-width: 900px) {
    padding-top: 65%; /* Slightly taller on mobile */
  }
`;


const StyledReactPlayer = styled(ReactPlayer)`
  position: absolute;
  top: 0;
  left: 0;
`;


const CloseButton = styled.button`
  position: absolute;
  top: -50px;
  right: 0;
  background: rgba(0, 0, 0, 0.7);
  color: rgba(100, 100, 100, 1);
  border: none;
  border-radius: 10px;
  width: auto;
  height: auto;
  font-size: 1rem;
  font-weight: 600;
  padding: 10px 12px;
  display: flex;
  align-items: center;
  gap: 6px;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  transition: background 0.2s, color 0.2s;
  
  &:hover {
    background: rgba(220, 74, 225, 0.7);
    color: #fff;
  }

  svg {
    margin-left: 4px;
  }
  
  @media (max-width: 900px) {
    top: -40px;
    font-size: 0.9rem;
    padding: 8px 12px;
  }
`;

const ModalCTA = styled.a`
  display: flex;
  align-items: center;
  gap: 20px;
  background: #DC4AE1;
  color: #fff;
  font-size: 1.1rem;
  font-weight: 600;
  border: none;
  border-radius: 8px;
  padding: 14px 24px;
  cursor: pointer;
  text-decoration: none;
  transition: background 0.15s;
  margin: 0 0 0 50px;
  &:hover {
    background: #9a41a7;
  }

  @media (max-width: 900px) {
    margin: 0 0 0 0;
    font-size: 0.8rem;
    padding: 10px 16px;
  }
`;

const ModalCtaWrapper = styled.div`
    display:flex;
    align-items:center;
    justify-content:center;
    background:  rgb(80, 80, 80, 1);
    padding: 20px;
    border-radius: 10px;
    margin-top: 20px;

    @media (max-width: 900px) {
        flex-direction: column;
        gap: 20px;
    }
`;
const ModalCtaMessage = styled.div`
    color: #fff;
`;

const DigitContainer = styled.div`
  display: inline-block;
  position: relative;
  width: 0.61em;
  height: 1.2em;
  overflow: hidden;
  vertical-align: top;
`;

const DigitStrip = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  transition: transform 0.6s ease-in-out;
  transform: translateY(${props => props.$offset}em);
`;

const SingleDigit = styled.div`
  height: 1.2em;
  line-height: 1.2em;
  text-align: center;
`;

const CountingNumber = ({ currentNumber }) => {

  const formatNumber = (num) => {
    return num.toLocaleString();
  };

  const renderDigitStrip = (targetDigit) => {
    return (
      <DigitStrip $offset={-targetDigit * 1.2}>
        {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map(digit => (
          <SingleDigit key={digit}>{digit}</SingleDigit>
        ))}
      </DigitStrip>
    );
  };

  const numberString = formatNumber(currentNumber);

  return (
    <span>
      {numberString.split('').map((char, index) => {
        if (char === ',') {
          return <span key={`comma-${index}`}>,</span>;
        }

        const digit = parseInt(char);
        return (
          <DigitContainer key={`digit-${index}`}>
            {renderDigitStrip(digit)}
          </DigitContainer>
        );
      })}
    </span>
  );
};




const MidSectionComponent = () => {

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [playerKey, setPlayerKey] = useState(0);

  function useScreenWidth() {
    const [width, setWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1920);
    useEffect(() => {
      function handleResize() { setWidth(window.innerWidth); }
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);
    return width;
  }

  const [isPlaying, setIsPlaying] = useState(false);
  const videoRef = useRef(null);

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setIsPlaying(false);
    setPlayerKey(k => k + 1);
  };



  useEffect(() => {
    if (isPlaying && videoRef.current) {
      videoRef.current.play();
    }
  }, [isPlaying]);


  useEffect(() => {
    if (!isModalOpen) return;
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') handleCloseModal();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isModalOpen]);

  const width = useScreenWidth();

  const [currentNumber, setCurrentNumber] = useState(8732179);

  useEffect(() => {
    const fetchUserCount = () => {
      axios.get('https://d3tjtx4blwmxgt.cloudfront.net/public/confirmed-user-count')
        .then(res => {
          if (res.data.count && res.data.count !== currentNumber && res.data.count > currentNumber) {
            setCurrentNumber(res.data.count);
          }
        })
        .catch(() => {
          console.log("Error fetching confirmed user count");
        });
    };

    fetchUserCount();
    const interval = setInterval(fetchUserCount, 60000);
    return () => clearInterval(interval);
  }, [currentNumber]);



  let carveRightX = 190;
  if (width < 1250) carveRightX = 185;
  if (width < 1225) carveRightX = 180;
  if (width < 1200) carveRightX = 177;
  if (width < 1175) carveRightX = 175;
  if (width < 1150) carveRightX = 170;
  if (width < 1125) carveRightX = 165;
  if (width < 1100) carveRightX = 162;
  if (width < 1075) carveRightX = 155;
  if (width < 1050) carveRightX = 152;
  if (width < 1025) carveRightX = 150;
  if (width < 1010) carveRightX = 147;
  if (width < 1000) carveRightX = 144;
  if (width < 990) carveRightX = 143;
  if (width < 980) carveRightX = 141;
  if (width < 975) carveRightX = 140;
  if (width < 970) carveRightX = 138;
  if (width < 965) carveRightX = 137;
  if (width < 960) carveRightX = 135;
  if (width < 950) carveRightX = 130;
  if (width < 925) carveRightX = 125;

  return (
    <MidSection>

      {isModalOpen && (
        <VideoModalOverlay onClick={handleCloseModal}>
          <VideoModalContent onClick={(e) => e.stopPropagation()}>
            <VideoContainer>
              <CloseButton onClick={handleCloseModal} aria-label="Close video">
                Close
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18 6L6 18"
                    stroke="currentColor"
                    strokeWidth="3"
                    strokeLinecap="round"
                  />
                  <path
                    d="M6 6L18 18"
                    stroke="currentColor"
                    strokeWidth="3"
                    strokeLinecap="round"
                  />
                </svg>
              </CloseButton>
              <StyledReactPlayer
                url={caseStudyVideo}
                playing
                controls
                width="100%"
                height="100%"
                config={{
                  file: {
                    attributes: {
                      controlsList: "nodownload",
                    },
                  },
                }}
              />
            </VideoContainer>

            <ModalCtaWrapper>
              <ModalCtaMessage>Save time and money <br />with DoNotPay's AI</ModalCtaMessage>
              <ModalCTA
                href="https://donotpay.com/login"
                target="_blank"
                rel="noopener noreferrer"
              >
                Join {currentNumber?.toLocaleString()}+ Users
                <img src={whiteArrow} alt="Arrow icon" style={{ width: 20, height: 20 }} loading="lazy"  />
              </ModalCTA>
            </ModalCtaWrapper>
          </VideoModalContent>
        </VideoModalOverlay>
      )}
      <MidSectionBg src={bgLandingMid} alt="" loading="lazy"  />
      <MidSectionContent>
        <MidSectionTitle>
          <MidSectionTitle>
            Join <MidSectionHighlight><CountingNumber currentNumber={currentNumber} />+</MidSectionHighlight> users
          </MidSectionTitle>
        </MidSectionTitle>
        <MidSectionTextWrapper>
          <MidSectionText>
            DoNotPay is a highly motivated team that's been fighting for consumers for over 10 years. We've helped people save millions of dollars by canceling unwanted subscriptions, lowering bills, beating tickets, and more.
          </MidSectionText>
          <CtaWrapper>
            <MidSectionCTA onClick={() => window.location.href = 'https://donotpay.com/login'}>
              Start Saving Money
              <img src={whiteArrow} alt="Arrow icon" style={{ width: 20, height: 20 }} loading="lazy"  />
            </MidSectionCTA>
            <DisclaimerText>
              Everyone’s situation is different. Of course, our self help tools are not guaranteed to help with every situation.
            </DisclaimerText>
          </CtaWrapper>
        </MidSectionTextWrapper>
        <MidSectionGrid>
          <MidSectionGridRow>
            <VideoTile>
              <VideoPlayer>
                <ReactPlayer
                  key={playerKey}
                  controls={true}
                  width="100%"
                  height="100%"
                  playIcon={
                    <PlayButton>
                      <img
                        src={playIcon}
                        alt="Play"
                        style={{ width: 26, height: 26 }}
                        loading="lazy" 
                      />
                    </PlayButton>
                  }
                  url={caseStudyVideo}
                  light={caseStudyVideoPoster}
                  playing={isPlaying}
                  onClickPreview={() => {
                    setIsModalOpen(true);
                    setIsPlaying(false);
                  }}
                  config={{
                    file: {
                      attributes: {
                        controlsList: "nodownload",
                      },
                    },
                  }}
                />
              </VideoPlayer>
              <StatsRow>
                <StatColumn style={{ flex: 1.5 }}>
                  <MidTileAuthor style={{ margin: 0, alignItems: 'center' }}>
                    <MidTileAuthorImg src={avatarCaseStudy} alt="Tyrone Davis" loading="lazy"  />
                    <MidTileAuthorInfo>
                      <MidTileAuthorName>Tyrone Davis</MidTileAuthorName>
                      <MidTileAuthorDesc>DoNotPay User</MidTileAuthorDesc>
                    </MidTileAuthorInfo>
                  </MidTileAuthor>
                </StatColumn>

                <StatColumn>
                  <StatValue>$150+</StatValue>
                  <StatDescription>saved on parking ticket</StatDescription>
                </StatColumn>

                <StatColumn>
                  <StatValue>100+</StatValue>
                  <StatDescription>free drinks and coupons received</StatDescription>
                </StatColumn>

                <StatColumn>
                  <StatValue>5+ years</StatValue>
                  <StatDescription>as a DoNotPay Subscriber</StatDescription>
                </StatColumn>
              </StatsRow>

            </VideoTile>

            <UpperRightTile>
              <MidTileText>
                “I’ve sent 372 letters through DoNotPay. I saved 150+ hours, avoided dozens of post office trips, and centralized all my proof of mailing in one dashboard.”
              </MidTileText>
              <MidTileStats>
                <MidTileStat>
                  <MidTileStatValue>372</MidTileStatValue>
                  <MidTileStatDesc>letters sent</MidTileStatDesc>
                </MidTileStat>
                <MidTileStat>
                  <MidTileStatValue>150+</MidTileStatValue>
                  <MidTileStatDesc>hours saved</MidTileStatDesc>
                </MidTileStat>
              </MidTileStats>
              <RightTileBottom>

                <MidTileAuthorRight>
                  <MidTileAuthorInfo>
                    <MidTileAuthorName>Lonnie LuPardus</MidTileAuthorName>
                    <MidTileAuthorDesc>User for 3+ years, <br />small business owner</MidTileAuthorDesc>
                  </MidTileAuthorInfo>
                </MidTileAuthorRight>
                <MidTileCtaRight
                  as="a"
                  href="https://donotpay.com/login"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Try Now
                  <img src={whiteArrow} alt="Arrow icon" style={{ width: 20, height: 20 }} loading="lazy" />
                </MidTileCtaRight>
              </RightTileBottom>
            </UpperRightTile>
          </MidSectionGridRow>
          {/* Bottom row: 3 tiles in a row, flexbox */}
          <LowerRow>
            <MidTileBottomLeft
              onClick={() => window.location.href = 'https://donotpay.com/login'}
            >
              <MidTileBottomLeftText>
                “I have tried this and it ACTUALLY works! I used to hate getting robocalls, but at least I’m hopeful in knowing there may be a $500 check headed my way.”
              </MidTileBottomLeftText>
              <MidTileAuthor style={{ alignItems: 'flex-start', marginTop: '0px' }}>
                <MidTileAuthorInfo>
                  <MidTileAuthorName>Jorge Soriano</MidTileAuthorName>
                  <MidTileAuthorDesc>CFP, EA</MidTileAuthorDesc>
                </MidTileAuthorInfo>
              </MidTileAuthor>
            </MidTileBottomLeft>
            <MidTileCenter
              $carveTopY={100}       // Like mask 3
              $carveHorzY={93}
              $carveRightX={carveRightX}
            >
              <MidTileCenterText>
                100+ products that will save or make you money right away
              </MidTileCenterText>
              <MidTileCenterCTA
                as="a"
                href="https://donotpay.com/login"
                target="_blank"
                rel="noopener noreferrer"
              >
                Start Saving Today
                <img src={midTileArrow} alt="Arrow icon" loading="lazy" />
              </MidTileCenterCTA>
            </MidTileCenter>
            <LowerRightTile>
              <MidStatValue><CountingNumber currentNumber={currentNumber} /></MidStatValue>
              <MidStatSubtext>DoNotPay Total Users</MidStatSubtext>
            </LowerRightTile>
          </LowerRow>
        </MidSectionGrid>
      </MidSectionContent>
    </MidSection>
  )
}

export default MidSectionComponent
